import { Fragment } from 'react';
import { Link } from '@atoms/index';
const Breadcrumbs = ({
    children,
    separator = '>',
    className = 'flex pb-4',
}) => {
    const BreadCrumbLink = ({ href = '', label, active }) => {
        return (
            <li className="md:pr-2 pr-1">
                <Link
                    href={href}
                    className={`text-xs line-clamp-1 md:line-clamp-none lg:text-sm md:text-sm no-underline ${active ? 'text-gray-900 cursor-text' : 'text-gray-500'
                        }`}
                    children={label}
                />
            </li>
        );
    };

    return (
        <nav className="">
            <ol className={className}>
                {children.map((element, index) => {
                    return (
                        <Fragment key={index}>
                            <BreadCrumbLink
                                href={element.props.href}
                                label={element.props.label}
                                active={element.props.active}
                            />
                            {(() => {
                                if (index < children.length - 1) {
                                    return (
                                        <BreadCrumbLink
                                            label={separator}
                                        />
                                    );
                                }
                            })()}
                        </Fragment>
                    );
                })}
            </ol>
        </nav>
    );
};
export default Breadcrumbs;
